import Icon from '@components/v2/ui/Icon/Icon';
import { Box } from '@mui/material';
import { GripVertical } from 'lucide-react';
import { ReactNode } from 'react';
import SortableItem from '../../../../../components/DragAndDrop/SortableItem';
import {
  SortableItemContextProvider,
  useSortableItemContext,
} from '../../../../../components/DragAndDrop/SortableItemContext';
import { useCatalogBannerSortableTileStyles } from './catalogBannerSortableTile.styles';

interface CatalogBannerSortableTileProps {
  id: string;
  children: ReactNode;
}

const CatalogBannerTileContent = ({
  children,
}: Pick<CatalogBannerSortableTileProps, 'children'>) => {
  const { elementProps } = useSortableItemContext();
  const { classes } = useCatalogBannerSortableTileStyles();

  return (
    <Box className={classes.tile} {...elementProps.attributes} {...elementProps.listeners}>
      <Box aria-hidden className={`drag-handle ${classes.dragHandle}`}>
        <Icon icon={GripVertical} size="md" />
      </Box>
      {children}
    </Box>
  );
};

const CatalogBannerSortableTile = ({ id, children }: CatalogBannerSortableTileProps) => (
  <SortableItemContextProvider id={id}>
    <SortableItem>
      <CatalogBannerTileContent>{children}</CatalogBannerTileContent>
    </SortableItem>
  </SortableItemContextProvider>
);

export default CatalogBannerSortableTile;
